import { ADVISOR_SESSION_FRAGMENT } from '@src/gql/fragments/AdvisorSessionFragment'
import { gql } from '@src/lib/gql'

export const CONFIRM_ADVISOR_SESSION_PRECHARGE = gql`
  mutation ConfirmAdvisorSessionPrecharge($input: ConfirmAdvisorSessionPrechargeInput!) {
    confirmAdvisorSessionPrecharge(input: $input) {
      advisorSession {
        ...AdvisorSessionFragment
      }
      precharge {
        id
        advisorSessionChargeId
        advisorSessionId
        amountUsd
        statusKey
        stripePaymentIntentId
      }
    }
  }
  ${ADVISOR_SESSION_FRAGMENT}
`
